import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "../../../models/app-filter.model";
import { AbImpedimento } from "app/abstract/full-pages/area-comum/impedimento.abstract";

@Injectable({ providedIn: 'root' })
export class ImpedimentoService extends AbImpedimento {

  public getImpedimentosByFilter(filter: AppFilter): Observable<any> {
    return this.get(`impedimentos/filter/${filter.encode()}`);
  }

  public getImpedimentosEFeriadosByAreaComumIdEEntreDatas(filter: AppFilter): Observable<any> {
    return this.get(`impedimentos/bloqueados/periodo/${filter.encode()}`);
  }
}